export default __webpack_public_path__ + "static/media/Major-Depression.59383530.jpg";